const currencymap = require('../models/currencymap.json');
const $ = window.jQuery;

export function genSelect(seleter, options = [], value, name, className = '', onChange, onInitialize, multi = false) {
  let nameHtml = name ? ` name="${name}"` : '';
  let classHtml = className ? ` class="select ${className}"` : ' class="select"';
  let html = `<select${nameHtml}${classHtml} required ${multi ? "multiple" : ""}>`;
  options.forEach(element => {
    if (typeof element === 'string') {
      html += `<option ${element + '' === value + '' || (Array.isArray(value) && value.includes(element + '')) ? 'selected' : ''} value='${element}'>${element}</option>`;
    }
    if (element && typeof element === 'object') {
      html += `<option ${element.value + '' === value + '' || (Array.isArray(value) && value.includes(element.value + '')) ? 'selected' : ''} value='${element.value}'>${element.label || element.value}</option>`;
    }
  });
  html += `</select$>`;
  seleter.append($(html));
  seleter.find('select').selectize({
    placeholder: "Select...",
    maxItems: multi ? null : 1,
    onDropdownOpen: function () {
      if (!multi) {
        this.latest = this.getValue() || this.latest;
        this.$input.get(0).selectize.clear(true);
      }
    },
    onBlur: function () {
      if (this.getValue() === '' && !multi) {
        this.setValue(this.latest);
      }
    },
    onChange: function (value) {
      if (multi) {
        if (typeof onChange === 'function') {
          onChange(value);
        }
      } else {
        if (value && value !== this.latest) {
          if (typeof onChange === 'function') {
            onChange(value);
          }
        }
      }
    },
    onInitialize: function (value) {
      if (typeof onInitialize === 'function') {
        onInitialize(this.getValue() || this.latest);
      }
    }
  });
}

export const genCurrencySelect = (seleter, value) => {
  let html = `<select class="select-currency" required>`;
  const selected = value || 'USD';
  for (let k in currencymap) {
    if (typeof currencymap[k] !== 'function') {
      html += `<option ${k === selected ? 'selected' : ''} value='${k}'>${k}</option>`;
    }
  }
  html += `</select>`;
  seleter.append($(html));
  seleter.find('select').selectize({
    placeholder: "USD",
    onDropdownOpen: function () {
      this.latest = this.getValue() || this.latest;
      this.$input.get(0).selectize.clear(true);
    },
    onBlur: function () {
      if (this.getValue() === '') {
        this.setValue(this.latest);
      }
    },
  });
}

export function genUnit(seleter, options, value) {
  if (Array.isArray(options)) {
    return genSelect(seleter, options, value);
  }
  return seleter.append($(`<div class='text'>${options}</div>`));
}

export const getOption = (options, value) => {
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if (option.value === value) {
      return option;
    }
  }
}